const BAR_WIDTHS = ["w-full", "w-5/6", "w-4/6", "w-full", "w-3/6"];

export function ChartSkeleton() {
	return (
		<output className="block py-1" aria-label="Loading chart">
			<div className="flex items-center gap-1.5 mb-2.5 text-[10px] font-mono text-base-content/40">
				<span className="inline-block w-3 h-3 rounded-full border-2 border-primary/25 border-t-primary animate-spin" />
				<span>loading…</span>
			</div>
			<div className="space-y-1.5 animate-pulse">
				{BAR_WIDTHS.map((width, i) => (
					<div
						key={`${width}-${i}`}
						className={`h-3 rounded bg-base-content/10 ${width}`}
					/>
				))}
			</div>
		</output>
	);
}
